<!--
2024-07-10 YTW 邀请排行榜
-->
<template>
  <div class="main-content" id="main-content">
    <div class="relative">
      <TopBack style="position: relative" :title="$t('lang.depositBonus.title')"/>
      <div class="banner">
        <img
          src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/1vf9yvogveq6ucb5b8ocxd7dlax0v3yyPGE_2500_banner.webp"
          alt=""/>
      </div>
      <div class="sub-bars">
        <div class="left">
          <div class="yesterday">{{
              $t('lang.depositBonus.Yesterday')
            }} {{ separateThousandInteger(UserData.MyDepositAmount) }}
          </div>
          <div class="bonus">{{ $t('lang.depositBonus.Bonus') }} {{ separateThousandInteger(UserData.MyAward) }}</div>
        </div>
        <div class="right">
          <div class="depositBtn0" v-if="UserData.MayCollectButton === -1">{{ $t('lang.depositBonus.Claim') }}</div>
          <div class="depositBtn1" v-if="UserData.MayCollectButton === 0" @click="claimReward">
            {{ $t('lang.depositBonus.Claim') }}
          </div>
          <div class="depositBtn2" v-if="UserData.MayCollectButton === 1">{{ $t('lang.bonus.claimed') }}</div>
        </div>
      </div>
      <div class="table">
        <div class="caption">
          <div>{{ $t('lang.account.amount') }}</div>
          <div>{{ $t('lang.account.bonus') }}</div>
        </div>
        <div class="tr" v-for="(item,index) in AmountAndBonus" :key="index">
          <div>{{ item.DepositAmount }}</div>
          <div>{{ item.Reward }}</div>
        </div>
      </div>
      <div class="depositButton" @click="goto('Deposit','UpiGuide')">{{ $t('lang.depositBonus.DepositNow') }}</div>
      <div class="how2useUPI" @click="how2UseUpi">{{ $t('lang.depositBonus.how2UseUpi') }}</div>
      <div class="rules">
        <div class="title">{{ $t('lang.depositBonus.rule') }}</div>
        <div class="content">
          <p v-for="(rule,index) in $t('lang.depositBonus.rules')" :key="index">{{ formatRule(rule, index) }}</p>
        </div>
      </div>
    </div>
    <UpiHelpPop v-show="showUpiHelpPop"
                :handleClose="closeUpiHelp"></UpiHelpPop>
  </div>
</template>
<script>
import TopBack from '@/components/TopBack/index'
import {separateThousandInteger} from '@/utils'
import UpiHelpPop from '@/components/UpiHelpPop/index'
import request from '@/service'

export default {
  name: 'DepositBonus',
  data () {
    return {
      separateThousandInteger,
      StartDate: '',
      EndDate: '',
      StartTime: '',
      EndTime: '',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      isLogin: !!localStorage.getItem('userInfo'),
      modalShow: false,
      showUpiHelpPop: false,
      UserData: {
        MyDepositAmount: 0,
        MyAward: 0,
        MayCollectButton: 0
      },
      AmountAndBonus: []
    }
  },
  components: {
    TopBack,
    UpiHelpPop
  },
  watch: {},
  created () {
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    fetchData () {
      const url = '/innovation/deposit/gateway/get_data'
      const data = {UserId: this.userInfo ? this.userInfo.UserId : null}
      request('post', url, data, true).then(res => {
        this.EndDate = this.formatDate(res.EndDate)
        this.StartDate = this.formatDate(res.StartDate)
        this.StartTime = res.StartTime
        this.EndTime = res.EndTime
        this.AmountAndBonus = res.RewardsModel
        if (res.UserData) {
          this.UserData = res.UserData
        }
      }).catch((e) => {
        console.error(e)
      })
    },
    formatRule (rule, index) {
      if (index === 0) {
        rule = rule.replace('{start}', this.StartDate)
        rule = rule.replace('{end}', this.EndDate)
        rule = rule.replace('{startTime}', this.StartTime)
        rule = rule.replace('{endTime}', this.EndTime)
        return rule
      } else if (index === 1) {
        rule = rule.replace('{startTime}', this.StartTime)
        rule = rule.replace('{endTime}', this.EndTime)
        return rule
      } else {
        return rule
      }
    },
    formatDate (originalDateString) {
      // 创建 Date 对象
      const date = new Date(originalDateString)
      // 从 Date 对象获取年、月、日
      const year = date.getFullYear()
      // 注意，月份从 0 开始，所以要加 1
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 将月份和日期格式化成两位数
      const formattedMonth = month < 10 ? `0${month}` : `${month}`
      const formattedDay = day < 10 ? `0${day}` : `${day}`
      return `${formattedDay}/${formattedMonth}/${year}`
    },
    goto (path, key) {
      if (key) {
        this.$router.push({path: '/' + path, query: {key: key}})
      } else {
        this.$router.push({path: '/' + path})
      }
    },
    how2UseUpi () {
      this.showUpiHelpPop = true
    },
    closeUpiHelp () {
      this.showUpiHelpPop = false
    },
    claimReward () {
      if (!this.userInfo) {
        // this.$store.commit('setLoginPopShow', true)
        this.$router.push('/Login')
        return
      }
      if (this.UserData.MayCollectButton === 0) {
        const url = '/innovation/deposit/gateway/collect_reward'
        const data = {UserId: this.userInfo.UserId}
        request('post', url, data).then(res => {
          this.fetchData()
        }).catch((e) => {
          console.error(e)
        })
      }
    },
    closePanel () {
      this.modalShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: fixed;
  padding: 56px 0 70px 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(180deg, #0B0B0B 10.18%, #181010 100%);
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;

  .relative {
    position: relative;
    width: 100%;
    height: max-content;
    z-index: 0;
  }

  .banner {
    position: relative;
    top: 2.5vw;
    left: 50%;
    transform: translate(-50%);
    width: 91.277vw;
    height: 35.277vw;

    img {
      width: 100%;
      border-radius: 1.388vw;
    }
  }

  .sub-bars {
    position: relative;
    top: 5vw;
    left: 50%;
    transform: translate(-50%);
    width: 91.277vw;
    height: 16.6667vw;
    margin-bottom: 2.5vw;
    background: rgba(29, 29, 29, 0.8);
    border-radius: 2.222vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 6.5vw 0 3.6vw;

    .left {
      .yesterday {
        width: 100%;
        font-size: 3.333vw;
        font-weight: 500;
        color: #6D6D6D;
        line-height: 5vw;
      }

      .bonus {
        font-size: 5.277vw;
        font-weight: 700;
        text-align: left;
        color: #FFFFFF;
        line-height: 6vw;
      }
    }

    .right {
      font-family: Inter;
      font-size: 4.444vw;
      font-weight: 500;
      line-height: 8.333vw;
      text-align: center;

      .depositBtn0 {
        width: 25.277vw;
        height: 8.333vw;
        border-radius: 3.611vw;
        border: 0.1388vw solid #B9B9B9;
        color: #ACACAC;
        background: #2F2F2F;
      }

      .depositBtn1 {
        width: 25.277vw;
        height: 8.333vw;
        border-radius: 3.611vw;
        border: 0.1388vw solid #E2C18E;
        color: #FFE0A5;
      }

      .depositBtn2 {
        width: 25.277vw;
        height: 8.333vw;
        border-radius: 3.611vw;
        border: 0.1388vw solid #AEAEAE;
        background: #1C1C1C;
        color: #6B6B6B;
      }
    }
  }

  .table {
    position: relative;
    top: 6vw;
    left: 50%;
    transform: translate(-50%);
    width: 91.28vw;
    height: 55vw;
    background: #2B2B2B;
    border-radius: 2.2222vw;
    overflow-x: hidden;
    overflow-y: auto;

    .caption {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #1A1A1A;
      padding: 0 14.25vw;
      height: 10.214vw;
      font-size: 4.444vw;
      font-weight: 700;
      line-height: 10.214vw;

      div {
        text-align: center;
        width: 16.667vw;
      }
    }

    .tr {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 8.643vw;
      line-height: 8.643vw;
      padding: 1vw 14.25vw 0 14.25vw;
      border-bottom: 0.3vw solid;
      border-image: linear-gradient(90deg,
      rgba(211, 211, 211, 0) 0%,
      rgba(108, 108, 108, 0.54) 48.5%,
      rgba(174, 174, 174, 0.261692) 85%,
      rgba(209, 209, 209, 0) 100%) 1;

      div {
        text-align: center;
        width: 16.667vw;
        font-size: 3.888vw;
        font-weight: 500;
        color: #A1A1A1;
      }
    }

    .tr:last-of-type {
      border: none;
    }
  }

  .depositButton {
    position: relative;
    top: 10.75vw;
    left: 50%;
    transform: translate(-50%);
    background: linear-gradient(270.12deg, #DEBC86 -2.41%, #F7DEB8 113.36%);
    width: 74.444vw;
    height: 10.833vw;
    border-radius: 0.833vw;
    font-size: 4.444vw;
    font-weight: 500;
    line-height: 10.833vw;
    color: #000000;
    text-align: center;
  }

  .how2useUPI {
    position: relative;
    top: 15.25vw;
    left: 50%;
    transform: translate(-50%);
    text-align: center;
    color: #E1C08C;
    text-decoration: underline;
    font-size: 4.166vw;
    font-weight: 500;
    line-height: 4.625vw;
  }

  .rules {
    position: relative;
    top: 20.5vw;
    left: 50%;
    transform: translate(-50%);
    width: 90.555vw;
    height: max-content;
    margin-bottom: 20vw;

    .title {
      font-family: Inter;
      font-size: 5.277vw;
      font-weight: 700;
      line-height: 6.388vw;
      text-align: left;
      color: #FFFFFF;
      margin-bottom: 2vw;
    }

    .content {
      padding: 0 0 0 1.111vw;
      font-family: Inter;
      font-size: 4.16vw;
      font-weight: 500;
      text-align: left;
      color: #969696;
      height: max-content;

      p {
        margin-bottom: 1vw;
      }
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

.tbody::-webkit-scrollbar {
  display: none
}

</style>



// WEBPACK FOOTER //
// src/pages/DepositBonus/index.vue